import { PhoneCall01 } from '@untitled-ui/icons-react/build/cjs';
import React from 'react';
import { useTranslation } from 'react-i18next';
import TooltipCmp from 'src/components/TooltipCmp';
import { copyToClipboard } from 'src/utils/CommonFunctions';
import WalToast from 'src/utils/WalToast';

const ContactCopyButton: React.FC<{ phoneNumber?: string | null }> = ({ phoneNumber }) => {
    const { t } = useTranslation();

    if (!phoneNumber) return null;

    return (
        <TooltipCmp message={t('Twilio.Call')} childrenClassName="!flex">
            <button
                type="button"
                className="flex flex-none text-grayLight900 hover:text-primary"
                onClick={() => {
                    copyToClipboard(phoneNumber);
                    WalToast.copy(t('Common.Copied_to_clipboard') as string, '', 'copy-msg');
                }}
            >
                <PhoneCall01 className="w-3.5 h-3.5" />
            </button>
        </TooltipCmp>
    );
};

export default ContactCopyButton;
